import Image from "next/image";

export default function ArticleImage({
  src,
  alt,
  caption,
  video_embed,
  sizes = "(max-width: 640px) 100vw, (max-width: 1024px) 80vw, 718px",
}) {
  return (
    <figure className="mb-4">
      <div className="relative mx-auto w-full max-w-[718px] overflow-hidden">
        {video_embed ? (
          <div
            className="w-full h-full [&>iframe]:w-full [&>iframe]:h-full aspect-video"
            dangerouslySetInnerHTML={{ __html: video_embed }}
          />
        ) : (
          <Image
            src={
              src ||
              "https://cdn.rashtrabharat.com/media/2026/07/23161405/Placeholder.webp"
            }
            sizes={sizes}
            alt={alt}
            width={1200}
            height={800}
            className="w-full h-full object-cover"
            loading="eager"
            fetchPriority="high"
            decoding="async"
          />
        )}
      </div>

      {caption && (
        <figcaption className="text-center text-sm text-[#797979]">
          {caption}
        </figcaption>
      )}
    </figure>
  );
}
